import { useLocation } from 'react-router-dom';
import { GraphIntrasessionComponents } from '../../components/intrasession/graph-intrasession-components';

export default function IntrasessionDetails() {
  const location = useLocation();
  const state = location.state || {};

  return (
    <div className="col-12 d-flex flex-column align-items-center">
      <GraphIntrasessionComponents
        ingestionId={state.ingestionId}
        zipFileName={state.zipFileName}
        timeWalking={state.timeWalking}
        stepsTotal={state.stepsTotal}
        date={state.date}
        p_id={state.p_id}
        startDate={state.startDate}
        endDate={state.endDate}
        deviceModel={state.deviceModel}
      />
    </div>
  );
}
